import styled from 'styled-components';
import { Colors } from '~/config/Colors';
import Card from '~/pages/Sistema/componentes/Card';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  .content-projetos {
    background: ${Colors.Color13};
    width: 100%;
    height: 30rem;
    border-radius: 1rem;

    .header {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
      background: ${Colors.Color22};
      padding: 1.1rem;
      border-radius: 1rem 1rem 0 0;
      align-items: center;

      .titulo {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        background: ${Colors.Color2};
        border-radius: 0.4rem;
        padding: 0.15rem 0.8rem 0.15rem 0.3rem;
        width: fit-content;

        img {
          width: 1.4rem;
        }

        .title {
          font-size: 0.8125rem;
          font-weight: 700;
          color: ${Colors?.Color7};
          margin-left: 0.5rem;
        }
      }
      
      .filtro {
        display: flex;
        flex-direction: row;

        .item {
          width: 9rem;
          margin-left: 1rem;
          
          select {
            width: 100%;
            background: ${Colors.Color22};
          }
        }
      }
    }

    .body {
      height: calc(100% - 4.2rem);
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: row;

      .body-left {
        width: 15rem;
        z-index: 2;
        background: ${Colors.Color26};
        min-height: 100%;
        border-radius: 0 0 0 1rem;
          
        .body-header {
          padding: 0 1.3rem;
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        .body-content {
          width: 100%;
        }
      }

      .body-right {
        border-radius: 0 1rem 0 0;
        width: calc(100% - 15rem);
        height: 100%;
        overflow: auto;
        z-index: 1;

        .body-header {
          width: 100%;
        }

        .body-content {
          width: 100%;
          height: 40rem;
          padding: 1rem;
        }
      }

      .body-header {
        width: 100%;
        background: ${Colors.Color2};
        height: 4rem;
        position: sticky;
        top: 0px;

        .info-cab {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          background: ${Colors.Color27};
          border-radius: 0.4rem;
          padding: 0.15rem 0.8rem 0.15rem 0.3rem;
          width: fit-content;

          p {
            font-size: 0.8125rem;
            font-weight: 700;
            color: ${Colors?.Color4};
            margin-left: 0.5rem;
          }
        }
      }

    }
  }

  .content-os {
    margin-right: 2rem;
  }

`;

export const BodyColuna = styled.div`
  height: ${(props) => props?.height};
`;

export const ThisCard = styled.div`
  .item {
    border-bottom: 2px solid ${Colors.Color22};
    border-right: 2px solid ${Colors.Color22};
    cursor: pointer;
    padding: 0em 0.7rem 0rem 0.7rem;
    display: flex;
    flex-direction: row;
    background: ${Colors.Color26};
    width: 100%;
    align-items: center;

    .item-colunas {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      height: 3rem;
      position: relative;

      .item-col-quant {
        width: fit-content;
        background: #F0C33C;
        padding: 0.1rem 0.2rem;
        border-radius: 1rem;
        position: absolute;
        right: 0;
        top: 0.6rem;
        min-width: 1.1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .quant {
          font-size: 0.55rem;
          color: ${Colors.Color26};
          font-weight: 800;
        }
      }

      .row-coluna {
        margin-left: 0.6rem;
        
        p {
          font-size: 0.7rem;
          font-weight: 700;
          color: ${Colors.Color4};
        }
      }
    }
  }
  
  .item.ativo {
    .limite {
      height: 3rem;
      width: 0.15rem;
      background: #6796cf;
      margin-left: -0.7rem;
      margin-right: 0.7rem;
    }
  }
`;

export const ThisCardProj = styled(Card)`
  margin-bottom: 0.6rem;
  padding: 0.8rem;
  border-radius: 0.6875rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 5.5625rem;
  position: relative;
  background: ${localStorage.getItem("tema") == "E" ? Colors.Color22 : Colors.Color22};
  box-shadow: none !important;

  .card-header {
    width: 100%;

    .card-header-top {
      background: ${Colors.Color4};
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      width: fit-content;
      padding: 0.2em 0.4rem;
      border-radius: 0.3rem;
      margin-bottom: 0.4rem;

      .codigo {
        font-size: 0.55rem;
        color: ${Colors.Color26};
        font-weight: 800;
      }
    }

    .titulo {
      color: ${Colors.Color4};
      font-size: 0.65rem;
      font-weight: 700;
    }

    .cliente {
      color: ${Colors.Color20};
      font-size: 0.55rem;
      font-weight: 600;
    }
  }

  .card-footer {
    width: 26rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;

    .card-footer-top {

      .card-content {
        display: flex;
        flex-direction: row;
        align-items: center;

        .titulo {
          font-size: 0.65rem;
          font-weight: bold;
          color: ${Colors.Color14};
          margin-left: 0.5rem;
        }

        .progress {
          width: 15rem;
          margin-left: 0.5rem;
          border-radius: 1rem;
          background: ${localStorage.getItem("tema") == "E" ? "#1D1D1D" : "#FFFFFF"};
          height: 0.8rem;
        }
      }
    }
    
    .card-footer-bottom {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;

      .card-footer-data {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: 1rem;

        .fundo-img {
          background: ${Colors.Color13};
          width: 1.2rem;
          height: 1.2rem;
          border-radius: 1rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-right: 0.5rem;

          img {
            width: 0.7rem;
          }
        }

        p {
          color: ${Colors.Color14};
          font-size: 0.65rem;
          font-weight: 700;
        }
      }

      .card-footer-priori {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        .titulo {
          color: ${Colors.Color14};
          font-size: 0.65rem;
          font-weight: 700;
        }
      }
    }
  }
`;

export const ThisCardColor = styled.span`
  background: #${props => (props?.cor ? props?.cor : Colors.Color4)};
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 1rem;
  margin-right: 0.4rem;
`;

export const ThisProgress = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  content: "";
  width: ${props => props?.width};
  height: 0.8rem;
  border-radius: 1rem;
  background: ${props => props?.backgound};
`;

